import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useTheme } from '@emotion/react';
import IconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';

import Alert, { useAlert } from 'components/snacks/Alert';

import { iranServerColumns, numSeperator, removeStorage } from 'utils/DataBase';
import { getVPSIran } from 'api/Api';

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        sx={{ mr: 2.5 }}
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>

      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};

export default function StickyHeadTable() {
  const [loading, setLoading] = useState(false);
  const [dataVPS, setDataVPS] = useState([]);
  const [len, setLen] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const alert_timeout = 10000;
  const alertStore = useAlert(alert_timeout);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
    const selector1 = document.querySelector('#iranPagination p');
    selector1.classList.add('yekan-font');
    selector1.innerHTML = 'ردیف در هر صفحه';
    setLoading(true);
    getVPSIran((isOk, data) => {
      if (isOk) {
        setLoading(false);
        setDataVPS(data);
        setLen(data.length);
      } else {
        setLoading(false);
        alertStore.AddAlert({
          key: '400',
          message: data,
          severity: 'error',
          auto_hide: true
        });
      }
    });
  }, []);

  return (
    <>
      {loading && (
        <div className={'d-flex justify-content-start align-items-center'}>
          <h1>در حال بارگذاری...</h1>
          <Box sx={{ display: 'flex', marginRight: '20px' }}>
            <CircularProgress />
          </Box>
        </div>
      )}
      <Paper
        id={'serverIran'}
        elevation={1}
        sx={{ overflow: 'hidden', padding: '20px 35px' }}
      >
        <div
          className="card-header d-flex justify-content-between align-items-center py-3 gap-2 gap-md-5"
          data-select2-id="select2-data-133-8g4r"
        >
          <div className="card-title">
            <div className="d-flex align-items-center position-relative my-1">
              <i className="bi bi-hdd-network f-13 text-dark me-3" />
              <h6>لیست سرورهای ایران</h6>
            </div>
          </div>
        </div>
        <TableContainer>
          <Table stickyHeader aria-label="sticky table">
            <TableHead sx={{ BackgroundColor: '#eaeaea' }}>
              <TableRow>
                {iranServerColumns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: column.minWidth,
                      fontFamily: 'yekan',
                      fontSize: '1em',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {dataVPS &&
                dataVPS
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={index}
                        style={{
                          backgroundColor: index % 2 === 0 ? '#f0f6ff' : ''
                        }}
                      >
                        {iranServerColumns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              sx={{ fontFamily: 'yekan' + '!important' }}
                            >
                              {column.id === 'id' && <span>{index + 1}</span>}
                              {column.id === 'order' && (
                                <Link
                                  to={{
                                    pathname:
                                      '/services/server-iran/server-order',
                                    state: { id: row['id'] }
                                  }}
                                >
                                  <Button
                                    variant={'contained'}
                                    color={'primary'}
                                    className={'yekan-font'}
                                    onClick={removeStorage}
                                  >
                                    سفارش
                                  </Button>
                                </Link>
                              )}
                              {column.id === 'price' &&
                                (row['price'] ? (
                                  <div>
                                    <span className={'me-1'}>
                                      {numSeperator(value)}
                                    </span>
                                    <span>تومان</span>
                                  </div>
                                ) : (
                                  <span>---</span>
                                ))}
                              {column.id !== 'order' &&
                                column.id !== 'price' &&
                                column.id !== 'id' && <span>{value}</span>}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </TableContainer>
        <TableContainer>
          <Table>
            <TableHead />
            <TableBody>
              <TableRow>
                <TablePagination
                  id={'iranPagination'}
                  rowsPerPageOptions={[
                    5,
                    10,
                    25,
                    { label: 'All', value: 1000 }
                  ]}
                  colSpan={4}
                  count={len}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      'aria-label': 'rows per page'
                    },
                    native: true
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  style={{ display: 'flex' }}
                />
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {
        <Alert
          alerts={alertStore.alert}
          close={alertStore.RemoveAlert}
          timeout={alert_timeout}
        />
      }
    </>
  );
}
